// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1l0we","avatar":"style_avatar__1Qkae","menuIcon":"style_menuIcon__2C79S"};